/**
 * GxHint: a short sentence that opens on hover and on keyboard focus, closes on Escape (forecast marks, because lines, the range). The trigger is the child; the card is the same Popover the glossary uses.
 * Hover shows it without taking the pointer; focus pins it until the trigger loses focus or Escape is pressed.
 */
import { useId, useRef, useState, type ReactNode } from "react";
import { GxPopover, useSheetMode } from "./Popover";

export function GxHint({ text, label, className = "", testId, children }: { readonly text: ReactNode; readonly label: string; readonly className?: string; readonly testId?: string; readonly children: ReactNode }) {
  const [hover, setHover] = useState(false);
  const [focused, setFocused] = useState(false);
  const anchor = useRef<HTMLSpanElement>(null);
  const id = useId();
  const open = hover || focused;
  const sheet = useSheetMode();
  return (
    <span ref={anchor} className={`gx-hint ${className}`} onMouseEnter={() => { if (!sheet) setHover(true); }} onMouseLeave={() => setHover(false)}>
      <span className="gx-hint-t" tabIndex={0} data-testid={testId} aria-describedby={open ? id : undefined} onFocus={() => { if (!sheet) setFocused(true); }} onBlur={() => { if (!sheet) setFocused(false); }} onClick={() => setFocused(true)}>{children}</span>
      {open ? <GxPopover anchor={anchor} id={id} label={label} passive={!focused} returnFocus={false} onClose={() => { setFocused(false); setHover(false); }}><p>{text}</p></GxPopover> : null}
    </span>
  );
}
